// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2Avth","inputWrap":"styles_inputWrap__338U8","input":"styles_input__1yJyj"};